<div class="reset-password-body">
  <mat-card appearance="outlined" class="example-card">
    <mat-card-content>
      <h2 class="text-center">Reset Password</h2>
      <form (ngSubmit)="onSubmit()" [formGroup]="resetPasswordForm">
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 325px">
            <mat-label>New Password</mat-label>
            <input formControlName="newPassword" id="newPassword" matInput type="password">
            <mat-error *ngIf="resetPasswordForm.get('newPassword')?.invalid && resetPasswordForm.get('newPassword')?.touched">
              Password is required (min 6 characters).
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 325px">
            <mat-label>Confirm Password</mat-label>
            <input formControlName="confirmPassword" id="confirmPassword" matInput type="password">
            <mat-error *ngIf="resetPasswordForm.hasError('passwordMismatch')">
              Passwords do not match.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-row-login-btn">
          <button class="submitBtn" color="primary" mat-raised-button type="submit" [disabled]="loading || resetPasswordForm.invalid">
            <mat-progress-spinner *ngIf="loading" diameter="20" mode="indeterminate"></mat-progress-spinner>
            <span *ngIf="!loading">Reset Password</span>
          </button>
        </div>
      </form>
      <div class="text-center">
        <a routerLink="/">Back to Login</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>
